import React, { useState, useEffect } from 'react';
import CommonHeader from '@/components/CommonHeader';
import $i18n from '@/i18n';
import Requests from '@/services/request';
import { getQueryStringArgs } from '@/utils/url-parse';
import ColorTags from '@/components/ColorTags';
import { getApprovalsResult } from '@/utils/status';
import { formatTime } from '@/utils';
import './index.less';
import App from './app';
import Space from './space';
import { Loading } from '@b-design/fusion';
import JsapiAuth from './jsapiAuth';
import RedirectUrl from './redirectUrl';

// 面包屑
const breadcrumbConfig = [
  {
    key: 'approvals',
    breadcrumbName: $i18n.get({ id: 'aopf.pages.approvals.breadcrumbNameApprovals', dm: '审批' }),
    path: '/approvals',
  },
  {
    key: 'detalis',
    breadcrumbName: $i18n.get({ id: 'aopf.pages.approvals.breadcrumbNameDetalis', dm: '审批详情' }),
  },
];
const Detail: React.FC = () => {
  const { approveId, defaultActiveKey, spaceId } = getQueryStringArgs();
  const [approvalDetail, setApproveDetail] = useState<any>({});
  const [roleList, setRole] = useState('');
  const [title, setTitle] = useState('');
  const [approveResult, setApprovalResult] = useState('');
  const [loading, setLoading] = useState(false);

  // 获取详情数据
  const initDataSource = () => {
    setLoading(true);
    Requests.get('/rest/intercnn/approve/detail', {
      approveId,
    }).then((data) => {
      if (data) {
        setApproveDetail(data);
        getRole(data.approveTarget);
        setLoading(false);
        switch (data.type) {
          case 'SPACE_SETTLEMENT_APPROVE': {
            setTitle(data.extInfo?.space?.name);
            break;
          }
          case 'APP_URL_APPROVE':
          case 'JSAPI_APP_APPROVE':
          case 'VERSION_PUBLISH_APPROVE': {
            setTitle(data.extInfo?.description?.name);
            break;
          }

        }
        // 审批操作结果
        setApprovalResult(data.approveAction);
      }
    });
  };
  // 获取空间权限
  const getRole = (value) => {
    Requests.get('/rest/intercnn/space/query', {
      spaceIds: value,
    }).then((data) => {
      if (data) {
        setRole(data.list[0].role?.split(',') || []);
      }
    });
  };
  // 渲染判断
  const getType = (data) => {
    switch (data) {
      case 'VERSION_PUBLISH_APPROVE': {
        return <App initDataSource={initDataSource} roleList={roleList} versionDetail={approvalDetail} />;
      }
      case 'SPACE_SETTLEMENT_APPROVE': {
        return <Space initDataSource={initDataSource} roleList={roleList} versionDetail={approvalDetail} />;
      }
      case 'JSAPI_APP_APPROVE':
        return <JsapiAuth initDataSource={initDataSource} roleList={roleList} approvalDetail={approvalDetail} />;
      case 'APP_URL_APPROVE': 
      return <RedirectUrl initDataSource={initDataSource} roleList={roleList} approvalDetail={approvalDetail} />
    }
  };

  // const getType=(data)=>{
  //   if(data=='SPACE_SETTLEMENT_APPROVE'){
  //     return  <App initDataSource={initDataSource} role={role} versionDetail={approvalDetail} />
  //   }else if(data=='VERSION_PUBLISH_APPROVE'){
  //     return <Space initDataSource={initDataSource} role={role} versionDetail={approvalDetail} />
  //   }
  // }

  useEffect(() => {
    initDataSource();
  }, []);

  return (
    <div className="approvals-detail">
      {/* {loading && <Spining />} */}
      <Loading type="circle" visible={loading} style={{ width: '100%' }}>
        <div className="header-container">
          <CommonHeader
            title={title}
            backTo={`/approvals?spaceId=${spaceId || ''}&defaultActiveKey=${defaultActiveKey}`}
            breadcrumbs={breadcrumbConfig}
          />
        </div>
        <div className="approvals-banner">
          <div className="banner-status">
            <span className="banner-des">
              {$i18n.get({
                id: 'aopf.pages.approvals.banner.status',
                dm: '状态',
              })}
            </span>
            {approveResult ? (
              <ColorTags {...getApprovalsResult(approveResult)} />
            ) : (
              <ColorTags {...getApprovalsResult('APPROVE')} />
            )}
          </div>
          <div className="banner-applicant">
            <span className="banner-des">
              {$i18n.get({
                id: 'aopf.pages.approvals.banner.applicant',
                dm: '申请人',
              })}
            </span>
            <span>{approvalDetail?.createName}</span>
          </div>
          <div className="banner-applicationTime">
            <span className="banner-des">
              {$i18n.get({
                id: 'aopf.pages.approvals.banner.applicationTime',
                dm: '申请时间',
              })}
            </span>
            <span>{formatTime(approvalDetail?.gmtCreate)}</span>
          </div>
          {/* <div className="banner-category">
            <span className="banner-des">
              {$i18n.get({
                id: 'aopf.pages.miniAppStore.select.category',
                dm: '类目',
              })}
            </span>
            <span>系统类目</span>
          </div> */}
        </div>
        {/* {approvalDetail?.type == 'VERSION_PUBLISH_APPROVE' ? (
        <App initDataSource={initDataSource} role={role} versionDetail={approvalDetail} />
      ) : (
        <Space initDataSource={initDataSource} role={role} versionDetail={approvalDetail} />
      )} */}
        <>{getType(approvalDetail?.type)}</>
      </Loading>
    </div>
  );
};
export default Detail;
